import { useIssueStore } from '../../../store';

export type IssueDocumentationOperationsContextType = {
  exportPending: boolean;
  importPending: boolean;
  removePending: boolean;
  lastError: string | null;
  setLastError: (message: string | null) => void;
  exportToDocumentation: ReturnType<
    typeof useIssueStore.getState
  >['exportToDocumentation'];
  importFromDocumentation: ReturnType<
    typeof useIssueStore.getState
  >['importFromDocumentation'];
  removeLinkedDocumentation: ReturnType<
    typeof useIssueStore.getState
  >['removeLinkedDocumentation'];
};

export function useIssueDocumentationOperations(): IssueDocumentationOperationsContextType {
  const actionStates = useIssueStore.use._actionStates();
  const lastError = useIssueStore.use.lastError();
  const setLastError = useIssueStore.use.setLastError();
  const exportToDocumentation = useIssueStore.use.exportToDocumentation();
  const importFromDocumentation = useIssueStore.use.importFromDocumentation();
  const removeLinkedDocumentation =
    useIssueStore.use.removeLinkedDocumentation();

  return {
    exportPending: actionStates.exportToDocumentation.loading,
    importPending: actionStates.importFromDocumentation.loading,
    removePending: actionStates.removeLinkedDocumentation.loading,
    lastError,
    setLastError,
    exportToDocumentation,
    importFromDocumentation,
    removeLinkedDocumentation,
  };
}
